export default {
  fronzeAmount: 'Frozen Amount',
  toShare: 'To Share',
  totalAmount: 'Total Amount',
  convertInto: 'Converting into Withdrawable Amount',
  crypto: 'Crypto',
  cryptoWithdraw: 'To Crypto',
  applicationDialogTitle: 'Crypto Withdrawal Info Application',
  phoneNumber: 'Mobile No.',
  email: 'Email',
  usdtAddress: 'USDT Address',
  usdtChain: 'USDT Chain',
  applyWithdrawAmount: 'Withdrawal Amount',
  apply: 'Apply',
  withdrawApplySuccess: 'Crypto withdrawal application was submitted successfully.',
  recordTip: 'Click to check withdraw history',
  tip: 'Tip:Please provide correct bank information to avoid withdrawal failure',
  phoneNum: 'Phone Number',
  phoneError: 'Please enter correct phone number',
  holderName: 'Account Holder Name',
  holderNameError: 'Please enter bank account holder name',
  bankNumbervalidator: 'The format is wrong, please make sure the number you entered is correct',
  holderNamevalidator:
    'Only contain letters and spaces, must start with a letter, and no more than 28 characters',
  accountNum: 'Account Number',
  accountNumError: 'Please enter the correct bank account number',
  IFSCCode: 'IFSC Code',
  IFSCCodeError:
    'Please enter correct IFSC code with the first four digits in capital letters and the fifth digit must be 0',
  toVerify: 'To Verify',
  verifyCodeError: 'Enter OTP',
  reqOpt: 'Request OTP',
  submit: 'Submit',
  delete: 'Delete',
  save: 'Save',
  delsuccess: 'Delete Success',
  hot: 'Hot',
  amazongiftcard: 'Amazon Gift Card',
  giftcarduse: 'Gift Card Usage Guide',
  howtouse: 'How to use Amazon gift card?',
  step1: 'Step 1',
  'step1desc-1': 'Go to',
  'step1desc-2': 'website or download Amazon App;',
  step2: 'Step 2',
  step2desc: 'Click Your Account or any other key words ‘gift card’;',
  step3: 'Step 3',
  step3desc: 'Click Add gift card to your balance;',
  step4: 'Step 4',
  step4desc: 'Copy gift card code to redeem, the number will add to your account automatically;',
  disclaimer: 'Disclaimer',
  processing: 'Processing',
  fail: 'Failed',
  withdrawalStatus: 'Withdrawal Status',
  withdrawalTime: 'Withdrawal Initated Time',
  code: 'Code',
  withdrawalID: 'Withdrawal ID',
  expirationTime: 'Expiration time',
  giftCard: 'Gift Card',
  account: 'Account',
  IFSC: 'IFSC',
  towhere: 'Balance Return',
  failReason: 'Reason',
  copyFail: 'Copy failed',
  redeemSuccess: 'Redeem Success',
  copy: 'Copy',
  desc: 'Please do not share the gift card code with anyone to avoid loss of your personal property, please use it as soon as possible within the validity period',
  cancel: 'Cancel',
  done: 'Done',
  close: 'Close',
  redeemdetail: 'Redeem Details',
  withdrawalMethod: 'Withdrawal Method',
  notAvail: 'Not Available',
  add: 'Add',
  withAmount: 'Withdrawal Amount', //提现金额
  withDraw: 'Withdraw',
  inputTips: 'Please provide correct bank information to avoid withdrawal failure',
  verifyCorrect: 'Verified correct, withdraw',
  addTitle: 'Add Withdrawal Method',
  editTitle: 'Edit Withdrawal Method',
  successInit: 'Successfully Initiated Withdrawal',
  afterFirst: 'After first invitation',
  get: 'Get',
  congratulation: 'Congratulations!Go to invite your friends to earn cash together!',
  sharewith: 'Share with friends',
  details: 'Details',
  withableAmount: 'Withdrawable Amount', //可提现金额
  converting: 'Converting into Withdrawable Amount',
  withdrawalThreshold: 'Withdrawal Threshold',
  togiftCard: 'To Gift Card',
  instant: 'Instant Arrives',
  nobankInfo: 'No Bank Info Needed',
  tobankAccount: 'To Bank Account',
  viewMore: 'View',
  faq: 'FAQ',
  redeemNow: 'Redeem Now',
  accountBlock: 'Account blocked!',
  contactTaurus: 'Please contact Taurus customer service for details.',
  contact: 'Contact',
  noData: 'No data',
  withdrawThres: 'Withdraw Threshold',
  withdrawThres1: 'Withdrawable amount reaches {amount} to withdraw',
  dearUser: 'Dear User',
  descdearUser:
    "Greetings from our online earning platform! We are delighted to have you as a valuable member of our community, and we hope you're enjoying the various opportunities to earn rewards by completing tasks and activities. Today, we want to provide you with important information regarding our Withdraw Threshold. ",
  withRecord: 'Withdrawal Record',
  myAsset: 'My Asset',
  record: 'Record',
  know: 'OK',
  sendOptmsg: 'OTP was send to you on you mobile phone',
  bank: 'Bank',
  inputPhoneTip: 'Enter Phone Number',
  inputAcnameTip: 'Enter Account Holder Name',
  inputAcnueTip: 'Enter Account Number',
  inputifCodeTip: 'Enter IFSC Code',
  inputVerifyCodeTip: 'Please enter',
  sendreqTip: 'OTP was send to you on you mobile phone',
  redeemGift: 'Redeem Gift Card',
  eyeTips:
    'When taking screenshots or recording screens, the card password should be hidden to avoid funds loss.',
  feedback: 'Feedback',
  viewfeedback: 'View Feedback',
  commonPro: 'Common Problem',
  one: 'One',
  two: 'Two',
  problem: {
    'pro-1-1': 'What is “Converting into Withdrawable Amount”?',
    'pro-1-2': '1. Your amount to be converted is all the cash in your account.',
    'pro-1-3':
      '2. The more amount to be converted you have, the more withdrawable amount you can get.',
    'pro-1-4': 'How can we earn more “Converting into Withdrawable Amount”?',
    'pro-1-5': '1. Share homepage games with your friends successfully.',
    'pro-1-6': '2. Share Taurus with your friends successfully.',
    'pro-1-7': 'How to quickly convert the amount into the withdrawable amount?',
    'pro-1-8': '1. Share homepage games with your friends',
    'pro-1-9': '2. Complete the tasks on the homepage',
    'pro-1-10': '3. Apply to have a mentor after upgrading into Lv3.',
    'pro-1-11': 'View More',
    'pro-1-12':
      'Q:What is the relationship between the withdrawable amount and “Converting into Withdrawable Amount”?',
    'pro-1-13':
      '1. The amount to be converted is your total assets in Taurus, and the withdrawable amount comes from the amount to be converted.',
    'pro-1-14':
      '2. You need to convert your amount into the withdrawable amount, then you can withdraw successfully. The more amount to be converted you have, the more withdrawable amount you can get.',
    'pro-1-15': '3. You can convert your withdrawable cash in the following ways',
    'pro-1-16':
      'Share the game on the homepage with your friends, and your friends need to keep active in the game.',
    'pro-1-17': 'Complete the tasks on the homepage to receive rewards',
    'pro-1-18': 'Apply to have a mentoer provided by the platform after Lv3',
    'pro-1-19':
      'Q. How can I quickly convert “Converting into Withdrawable Amount” into withdrawable cash?',
    'pro-1-20':
      'Share the game on the homepage to your friends through your favorite social software',
    'pro-1-21': 'Teach your friends how to play this game and earn money',
    'pro-1-22':
      'Your friends keep active in the game, and your cash will gradually be converted into withdrawable amount.',
    'pro-1-23': 'Q.What is the withdrawal threshold?',
    'pro-1-24':
      '1. Since bank transfers require deduction of processing fees, to avoid your loss, Taurus apply a phased withdrawal method and will bear all processing fees.',
    'pro-1-25': '2. It allows you to flexibly manage your income.',
    'pro-1-26':
      '3. There are only 6 withdrawal thresholds. After you reach the highest threshold, there will be no withdrawal thresholds anymore.',
    'pro-1-27': 'Withdrawal threshold',
    'pro-1-28': 'How can we quickly reach this threshold?',
    'pro-1-29': 'Complete novice tasks',
    'pro-1-30': 'Complete the tasks in the game',
    'pro-1-31': 'Apply to have a mentor',
    'pro-1-32': 'Share the game with your friends',
    'pro-1-33': 'Share Taurus with your friends',
    'pro-1-34': 'Become a Taurus mentor',
    'pro-1-35': 'Q. How do I confirm that my assets have been converted into withdrawable amount?',
    'pro-1-36':
      'When your cash is converted into withdrawable amount, the Taurus Assistant will send you a notification.',
    'pro-1-37':
      'You can also click the profile photo to check [commission details] and then go to [Withdrawable details] to check the source of the commission.'
  },
  problemTypes: 'Problem Types',
  problemTypesSelect: 'Please Select Problem Types',
  problemType: {
    'pro-1': 'Processing for more than 3 days',
    'pro-2': 'Successful but not credited',
    'pro-3': 'Failed but not refunded to account',
    'pro-4': 'Others'
  },
  issueDetails: 'Issue Details',
  issueDetailsEnter: 'Please Enter Issue Details',
  uploadBank: 'Upload bank statements or proofs',
  uploadBankEnter: 'Please Upload bank statements or proofs',
  uploadTip:
    'Supports uploading PDF and JPG, no more than 3 pictures, and no more than 10M file size',
  upload: 'Upload',
  image: 'Image',
  file: 'File',
  uploadFileTip: 'Upload bank statement in PDF format (within 10M)',
  uploadImageTip: 'At least one image uploaded',
  limitImageTip: 'Uploading up to 3 pictures',
  limitFileTip: 'Uploading up to 1 file',
  sumitsuccess: 'Submitted successfully',
  USER_PROCESSING: 'Feedback successful, waiting for \n customer service Processing',
  CUSTOMER_PROCESSING: 'Customer service replied',
  FINISHED: 'Customer service processing Completed',
  USER_PROCESSING_OUT: 'Feedback successful, waiting for \n customer service Processing',
  CUSTOMER_PROCESSING_OUT: 'Customer service \n feedback processing',
  FINISHED_OUT: 'Completed',
  feedbacked: 'Feedbacked',
  feedbackProcess: 'Feedback Process',
  customerServiceFeedback: 'Customer service feedback',
  userFeedback: 'User feedback',
  waitingForUserFeedback: 'Waiting for user feedback',
  waitingForServiceFeedback: 'Waiting for customer service feedback',
  safetyVerification: 'Safety Verification',
  safetyVerificationTip:
    'To avoid asset loss, please confirm that \n you are making the withdrawal yourself',
  safetyVerificationMsg: 'We will send OTP to your mobile phone',
  unReceiveOTP: "Didn't receive OTP?",
  resend: 'Resend',
  clickGo: 'Click to go',
  suggestion: 'Or use gift cards, 100% successfully arrived',
  go: 'Go',
  withdrawLimitText: 'Withdrawal Limit',
  accelerating: 'Accelerating',
  complete_one_task: 'Complete 1 task to arrive now',
  to_accelerate: 'To accelerate',
  withdrawal_initiated: 'Withdrawal initiated successfully',
  expected_to_arrive: 'Expected to arrive in 5-7 working days',
  withdrawal_initiated_short: 'Withdrawal initiated',
  provideUPI: 'Please provide correct UPI information to avoid withdrawal failure',
  inputUPIID: 'Please enter UPI ID',
  UPIID: 'UPI ID',
  addUPIID: 'Add UPI ID',
  minimumWithdrawal: 'Minimum withdrawal amount {amount} USDT',
  verifyPlachoder: 'please enter verification code',
  widthdrawWaitAuditDesc:
    'Your withdraw is under reviewing by Taurus Senior Manager,Click here to contact us',
  widthdrawRejectedDesc: 'Click here to contact Taurus Taurus Senior Manager',
  referralCompleted: 'Referral completed',
  pleaseGoToTaurusApp: 'Please return to the Taurus app to withdraw',
  withdrawCash: 'Withdraw Cash',
  toCrypto: 'To Crypto',
  toUpiCash: 'To UPI Cash',
  minimumWithdrawal: 'Minimum withdrawal amount {amount} USDT',
  usdtWithdrawHighDemandDesc:
    'USDT withdrawals are currently in high demand.Priority USDT allocation is reserved for high-performing agents over the past 30 days.<span>Increase your promotion efforts to unlock priority USDT withdrawal access.upgrade.</span>',
  withdrawUSDT: 'Withdraw USDT',
  withdrawalFee: 'Withdrawal Fee',
  usdtDeducted: 'The withdrawal fee will be deducted from your asset',
  usdtTips:
    'Please carefully verify your USDT Address and USDT Chain. Any losses incurred due to incorrect information will be borne by you.',
  modifyAmountTips:
    'Please enter a value within the range of &lt;span&gt;{low}&lt;/span&gt; to &lt;span&gt;{high}&lt;/span&gt;',
  pullTxt: 'Pull down to refresh...',
  loosingTxt: 'Release to refresh...',
  loadingTxt: 'Loading...',
  successTxt: 'Refresh successfully',
  errorTxt: 'Request failed, pull down to reload',
  noMore: 'No More',
  inviteNumFriend: 'Need to invite {num} more friend',
  inviteSuccess: 'Your friends has supported you',
  lv2Tip: "Get friends to Lv2 & Earn <span class='count'>&nbsp;{count}&nbsp;</span> commission",
  widthdrawInviteInitDesc:
    'Once you complete the invitation task, your withdrawal will be processed',
  successfullyWithdrawal: 'Successfully withdrawal',
  successRequest: 'Withdrawal request submitted successfully'
}
